module.exports = __webpack_public_path__ + "static/media/fail.21c5998b.svg";